import { GameSystems } from "./gameSystems";

export enum CampaignTraitType {
  Default,
  Injury,
  Talent,
  Skill
}

export const defaultTrait: ICampaignTrait = {
  id: undefined,
  name: "",
  description: "",
  enabledGameSystems: [2, 3, 4, 5, 6],
  type: CampaignTraitType.Default,
  skillSet: null
};

export interface ITrait {
  name: string;
  description: string;
}

export interface ISkillSet {
  id: string;
  name: string;
  traits: ITrait[];
}

export interface ICampaignData {
  units: ITrait[];
  heroes: ISkillSet[];
  injuries: ITrait[];
  talents: ITrait[];
}

export interface ICampaignTrait {
  id: string;
  name: string;
  description: string;
  descriptionOverride?: {
    skirmish?: string;
    regiments?: string;
  };
  enabledGameSystems: GameSystems[];
  type: CampaignTraitType;
  skillSet?: string;
}
